import React, { useRef, useState, useEffect } from "react";
import { Row, Image, Flex, Skeleton, Button } from "antd";
import { RightOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import ic_addcollection_contentlibrary from "../../../../../../../assets/images/svgs/ic_addcollection_contentlibrary.svg";
import ic_removecollection_contentlibrary from "../../../../../../../assets/images/svgs/ic_removecollection_contentlibrary.svg";
import {
  colorTextDesc,
  colorTextTitleMobile,
  ColorPrimary,
} from "../../../../../../../config/constant/color/index";
import defaultImage from "../../../../../../../assets/images/png/general/img_thumb_default.png";

// for translate
import { useTranslation } from "react-i18next";

// import history from "history/browser";
import { useNavigate, useLocation } from "react-router-dom";

const CourseDescriptionMobile = ({
  loading,
  wraperStyle,
  rowImageStyle,
  index,
  thumbnail,
  divRightStyle,
  pProgramStyle,
  titleCourseDescStyle,
  courseName,
  rowBottomFirstStyle,
  rowBottomSecondStyle,
  pointImageWidth,
  totalPoint,
  totalCourses,
  dividerStyle,
  description,
  overDue,
  flagBtnCollection,
  funcCollection,
  isCollection,
  setOpenModalDetailCourse,
  journeyId,
}) => {
  const { t, i18n } = useTranslation();

  const textRef = useRef(null);
  const [isClamped, setIsClamped] = useState(false);
  let navigate = useNavigate();

  let locationRouter = useLocation();
  const queryParams = new URLSearchParams(locationRouter.search);
  const hasParamFrom = queryParams.has("from");
  const hasParamSrc = queryParams.has("src");
  const pageFrom = hasParamFrom ? queryParams.get("from") : null;
  const valueSrc = hasParamSrc ? queryParams.get("src") : null;

  useEffect(() => {
    if (!loading && textRef.current) {
      const isTextClamped = textRef.current.clientHeight >= 76;
      setIsClamped(isTextClamped);
    }
  }, [textRef, loading]);

  const handleBack = (e) => {
    e.preventDefault();
    if (pageFrom === "home") {
      navigate("/home");
    } else if (valueSrc) {
      navigate(`/my-learning-journey?search=${valueSrc}`);
    } else {
      navigate(`/my-learning-journey/journey/${journeyId}`);
      location.reload();
    }
  };

  return (
    <>
      <div style={wraperStyle}>
        <Flex style={{ display: "flex", flexDirection: "column" }}>
          <Row className="row-image me-4" style={rowImageStyle}>
            {loading ? (
              <Skeleton.Avatar
                active
                shape="square"
                style={{ width: "99vw", height: "160px" }}
              />
            ) : (
              // thumbnail
              <Image
                width={"100%"}
                height={160}
                style={{
                  objectFit: "cover",
                  height: "100%",
                }}
                src={thumbnail}
                preview={false}
                fallback={defaultImage}
                alt="Course Thumbnail Mobile"
              />
            )}
            <div
              className="btn-back-mobile"
              style={{
                position: "absolute",
                top: "20px",
                left: "18px",
                cursor: "pointer",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
                boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.18)",
              }}
              onClick={(e) => handleBack(e)}
            >
              <ArrowLeftOutlined
                style={{
                  color: colorTextTitleMobile,
                  width: "15px",
                  height: "15px",
                }}
              />
            </div>
          </Row>
          <div className="div-right" style={divRightStyle}>
            {loading ? (
              <Skeleton.Input
                active
                size={16}
                style={{ marginBottom: "10px", minWidth: "70px" }}
              />
            ) : (
              <p className="p-course" style={pProgramStyle}>
                {t("feature.feature_mylj.main_content.course_cap")} {index}
              </p>
            )}
            <Row>
              {loading ? (
                <Skeleton.Input
                  active
                  size={22}
                  style={{
                    marginRight: "8px",
                    minWidth: "300px",
                    marginBottom: "6px",
                  }}
                />
              ) : (
                <span
                  className="title-journey-desc"
                  style={titleCourseDescStyle}
                >
                  {courseName}
                </span>
              )}
            </Row>
            <div ref={textRef}>
              {loading ? (
                <Skeleton
                  paragraph={{ rows: 10 }}
                  style={{ marginTop: "8px" }}
                  active
                />
              ) : (
                <div
                  className="text-description"
                  style={{
                    textAlign: "left",
                    lineHeight: "22px",
                    whiteSpace: "pre-wrap",
                    fontSize: "14px",
                    fontWeight: "400",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    marginTop: "12px",
                    color: colorTextDesc,
                  }}
                >
                  {description}
                </div>
              )}
            </div>
            {isClamped && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  justifyContent: "end",
                  color: ColorPrimary,
                  cursor: "pointer",
                  marginTop: "8px",
                }}
                onClick={() => setOpenModalDetailCourse()}
              >
                {loading ? (
                  <Skeleton.Input
                    active
                    size={20}
                    style={{ minWidth: "80px" }}
                  />
                ) : (
                  <>
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      {t("main.popup.more")}
                    </span>
                    <RightOutlined />
                  </>
                )}
              </div>
            )}
          </div>
          <div
            className="btn-collection"
            style={{
              position: "absolute",
              right: 0,
              display:
                flagBtnCollection !== undefined && flagBtnCollection !== null
                  ? "block"
                  : "none",
            }}
          >
            {loading ? (
              <Skeleton.Button
                active
                style={{
                  width: "140px",
                  height: "32px",
                  borderRadius: "6px",
                }}
              />
            ) : (
              <Button
                className={
                  isCollection
                    ? "btn-remove-collection-content-library"
                    : "btn-add-collection-content-library"
                }
                name={
                  isCollection
                    ? "btn-remove-program-collection-content-library"
                    : "btn-add-program-collection-content-library"
                }
                style={{
                  borderRadius: "6px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "auto",
                  marginLeft: "0",
                  width: "177px",
                }}
                onClick={() => funcCollection(isCollection ? "remove" : "add")}
                loading={loading}
              >
                <div
                  style={{
                    marginTop: "-3px",
                    marginRight: "4px",
                  }}
                >
                  <Image
                    preview={false}
                    src={
                      isCollection
                        ? ic_removecollection_contentlibrary
                        : ic_addcollection_contentlibrary
                    }
                  />
                </div>
                <span style={{ lineHeight: "normal" }}>
                  {isCollection
                    ? t(
                        "feature.feature_cl.main_collection_card.remove_from_collection",
                      )
                    : t(
                        "feature.feature_cl.collection_action.add_to_collection",
                      )}
                </span>
              </Button>
            )}
          </div>
        </Flex>
      </div>
    </>
  );
};

export default CourseDescriptionMobile;
